import script from "./KDivider.vue?vue&type=script&setup=true&lang=ts"
export * from "./KDivider.vue?vue&type=script&setup=true&lang=ts"

import "./KDivider.vue?vue&type=style&index=0&id=81cecde6&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81cecde6"]])

export default __exports__